module.exports = __webpack_public_path__ + "img/marker_two_blue1.66f0e1d4.png";